module.exports = __webpack_public_path__ + "img/confirm2_en.cd17cebd.png";